import { TabPanel } from "@headlessui/react-v2";
import type { ReactNode } from "react";

import { classNames } from "@/react/helpers/twMergeWithCN";

interface PanelProps {
  children: ReactNode;
  className?: string;
}

export const Panel = ({ children, className = "", ...props }: PanelProps) => (
  <TabPanel
    as="div"
    data-testid="tab-panel"
    className={classNames("size-full overflow-auto", className)}
    {...props}
  >
    {children}
  </TabPanel>
);

Panel.displayName = "Tab.Panel";
